import { bodyLanguage, law4, personalDevelopment, product1, product2, product3 } from "./assets/images";

export const data = [
    {id:1, image:law4},
    {id:2, image:bodyLanguage},
    {id:3, image:personalDevelopment}
]

export const carouselData = [
    {id:1, videoId:'qL6L8ZF_M60', image:"https://swiperjs.com/demos/images/nature-1.jpg"},
    {id:2, videoId:'njr9n2eTWiI', image:"https://swiperjs.com/demos/images/nature-2.jpg"},
    {id:3, videoId:'O8gH63fAvBQ', image:"https://swiperjs.com/demos/images/nature-3.jpg"},
    {id:4, videoId:'PGpscYPA7zI', image:"https://swiperjs.com/demos/images/nature-4.jpg"},
    {id:5, videoId:'TaIZhMOKNyU', image:"https://swiperjs.com/demos/images/nature-5.jpg"},
    {id:6, videoId:'1rpNkIcwNIM', image:"https://swiperjs.com/demos/images/nature-6.jpg"},
    {id:7, videoId:'ed7xMTav1Qc', image:"https://swiperjs.com/demos/images/nature-7.jpg"},
    {id:8, videoId:'dkv0QH-S7M0', image:"https://swiperjs.com/demos/images/nature-8.jpg"},
  ]

export const resources = [
    // {   id:1, 
    //     name:'Youtube Gear', 
    //     description:'AFFILIATE DISCLOSURE: there may be a few links in this description that, at no cost to you, will earn me a commission if you choose to click them and make a purchase 🙂. Don’t worry – I only ever promote things that have genuinely helped me.',
    //     content:[
    //         {
    //             contentTitle1: 'CAMERA: SONY A7S III',
    //             contentDescription1: 'This is perhaps one of the best cameras on the market right now, and although on the expensive side, it’s been a pleasure to use for videos on the main channel, my patreon, and wherever else I can use it.',
    //         },
    //         {
    //             contentTitle2: 'CAMERA: SONY A7S III',
    //             contentDescription2: 'This is perhaps one of the best cameras on the market right now, and although on the expensive side, it’s been a pleasure to use for videos on the main channel, my patreon, and wherever else I can use it.',
    //         }
    //     ]
    // },
    // {   id:2, 
    //     name:'My Video Editing PC', 
    //     description:'AFFILIATE DISCLOSURE: there may be a few links in this description that, at no cost to you, will earn me a commission if you choose to click them and make a purchase 🙂. Don’t worry – I only ever promote things that have genuinely helped me.',
    //     content: [
    //         {
    //             contentTitle1: 'CAMERA: SONY A7S III',
    //             contentDescription1: 'This is perhaps one of the best cameras on the market right now, and although on the expensive side, it’s been a pleasure to use for videos on the main channel, my patreon, and wherever else I can use it.',
    //         },
    //         {
    //             contentTitle2: 'CAMERA: SONY A7S III',
    //             contentDescription2: 'This is perhaps one of the best cameras on the market right now, and although on the expensive side, it’s been a pleasure to use for videos on the main channel, my patreon, and wherever else I can use it.',
    //         }
    //     ]
    // },
    // {   id:3, 
    //     name:'Tech Accessories', 
    //     description:'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio, neque qui velit. Magni dolorum quidem ipsam eligendi, totam, facilis laudantium cum accusamus ullam voluptatibus commodi numquam, error, est. Ea, consequatur.',
    //     // content:[
    //     //     {
    //     //         contentTitle1: 'CAMERA: SONY A7S III',
    //     //         contentDescription1: 'This is perhaps one of the best cameras on the market right now, and although on the expensive side, it’s been a pleasure to use for videos on the main channel, my patreon, and wherever else I can use it.',
    //     //     },
    //     //     {
    //     //         contentTitle2: 'CAMERA: SONY A7S III',
    //     //         contentDescription2: 'This is perhaps one of the best cameras on the market right now, and although on the expensive side, it’s been a pleasure to use for videos on the main channel, my patreon, and wherever else I can use it.',
    //     //     }
    //     // ]
    // },
    {   id:4, 
        name:'Buy a Planner', 
        description:'SHAYAN’S POWERFUL PRODUCTIVITY PLANNER',
        content :[
            {
                contentTitle1: 'FULFILL YOUR PURPOSE IN LIFE',
                contentDescription1: 'This Productivity Planner helps you create a vision of your life. As explained in this video, your short term goals have to be nested in your long term goals which are nested in your ultimate vision for your life. I use this planner to accomplish exactly that. It’s the most comprehensive yet compact planner I’ve used which gets me the results I’ve always sought after. Now it’s your turn!',
                image1: product1
            },
            {
                contentTitle2: 'BUILD YOUR CONFIDENCE AND INCREASE YOUR FULFILLMENT',
                contentDescription2: 'A crucially important component of becoming a confident, competent and charismatic figure is being able to deliver to yourself. By doing this, your perception of yourself changes. Things that you thought were impossible, all of a sudden become possible. You’ll gradually break your limiting beliefs by getting results and that alone will boost your confidence. There is a section in the daily planner where you can write down which personal and professional awareness you’re seeking. Perhaps it’s body language, your tone of voice or being more kind to certain individuals. You’ll set the tone first thing in the morning, and that shades your entire day. You’re getting closer to who you want to become step by step, day by day, page by page.',
                image2: product2
            },
            {
                contentTitle3: 'INCREASE YOUR PRODUCTIVITY & STAY FOCUSED',
                contentDescription3: 'This productivity planner is the perfect solution for you if you want to significantly increase your productivity and reach your goals, while also helping to increase your happiness through self-development using a proven system that uses positive psychological techniques. You are only a few days away from the difference!',
                image3: product3
            },
        ]
    }
]